import React, { useContext, useEffect, useState } from 'react';
import {
  CurrencyContext,
  CurrentCurrencyContext,
  HealthCareAddOnContext,
} from '../UserContext';
import CloseButton from './CloseButton';
import { useSearchParams } from 'react-router-dom';
import { getMonetaryUnitText, sessionStorageSetItem } from './Function';

const HealthCare = ({
  isReturnTrip,
  isHealthCareShowed,
  setIsHealthCareShowed,
  departHealthCarePackages,
  returnHealthCarePackages,
}) => {
  const { healthCareAddOn, setHealthCareAddOn } = useContext(
    HealthCareAddOnContext
  );

  const { currentCurrency, setCurrentCurrency } = useContext(
    CurrentCurrencyContext
  );

  const { exchangeCurrency, setExchangeCurrency } = useContext(CurrencyContext);

  const [searchParams] = useSearchParams();
  const noOfPax = Number(searchParams.get('passenger') || 1);

  const monetaryUnit = getMonetaryUnitText(currentCurrency);

  const [isReturn, setIsReturn] = useState(false);

  useEffect(() => {
    setIsReturn(isReturnTrip);
  }, [isReturnTrip]);

  useEffect(() => {
    for (let i = 0; i < departHealthCarePackages.length; i++) {
      const d = departHealthCarePackages[i];

      if (d.input_is_selected === 'True') {
        setHealthCareAddOn({
          addOnId: d.add_on_id,
          item: d.item_name,
          fee: Number(d.item_amt) * noOfPax,
          isReturn: false,
          addOnIndex: i,
          direction: d.direction,
          noOfPax,
          canDelete: false,
        });

        sessionStorageSetItem(
          'healthCareAddOn',
          JSON.stringify({
            addOnId: d.add_on_id,
            item: d.item_name,
            fee: Number(d.item_amt) * noOfPax,
            isReturn: false,
            addOnIndex: i,
            direction: d.direction,
            noOfPax,
            canDelete: false,
          })
        );
      }

      if (isReturnTrip && healthCareAddOn.fee > 0) {
        const returnTrip = returnHealthCarePackages.find(
          (_r) => d.item_name === _r.item_name && d.item_amt === _r.item_amt
        );

        if (returnTrip && returnTrip.input_is_selected === 'True') {
          setHealthCareAddOn({
            addOnId: [d.add_on_id, returnTrip.add_on_id],
            item: returnTrip.item_name,
            fee: Number(returnTrip.item_amt) * 2 * noOfPax,
            isReturn: true,
            addOnIndex: i,
            direction: [d.direction, returnTrip.direction],
            noOfPax,
            canDelete: false,
          });

          sessionStorageSetItem(
            'healthCareAddOn',
            JSON.stringify({
              addOnId: [d.add_on_id, returnTrip.add_on_id],
              item: returnTrip.item_name,
              fee: Number(returnTrip.item_amt) * 2 * noOfPax,
              isReturn: true,
              addOnIndex: i,
              direction: [d.direction, returnTrip.direction],
              noOfPax,
              canDelete: false,
            })
          );
        }
      }
    }

    if (!departHealthCarePackages && !returnHealthCarePackages) {
      setHealthCareAddOn({ item: '', fee: 0, isReturn: false });
      sessionStorageSetItem(
        'healthCareAddOn',
        JSON.stringify({ item: '', fee: 0, isReturn: false })
      );
    }
  }, []);

  if (!isReturnTrip && departHealthCarePackages.length < 1) {
    return null;
  }

  return (
    <div
      className='health-cares'
      style={{
        transition: 'all 0.2s ease-out',
        pointerEvents: isHealthCareShowed ? 'auto' : 'none',
        position: 'fixed',
        height: '100%',
        width: '100%',
        zIndex: 10,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        padding: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: isHealthCareShowed ? 1 : 0,
      }}
    >
      <div
        className='health-cares-wrapper'
        style={{
          width: '100%',
          maxWidth: '600px',
          backgroundColor: 'white',
          borderRadius: '3px',
        }}
      >
        <div className='add-on-title-wrapper'>
          <h5>Health Care Add On</h5>
          <div
            className='image-wrapper'
            onClick={() => setIsHealthCareShowed(false)}
          >
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
              <path d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z' />
            </svg>
          </div>
        </div>
        <div className='packages-container'>
          <div className='add-on-description-wrapper'>
            <p>
              <strong>Pick Heath Care Add On For Your Trip</strong>
            </p>
          </div>
          {departHealthCarePackages.length > 0
            ? departHealthCarePackages.map((_, index) => (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '10px',
                    padding: '10px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '10px',
                    backgroundColor:
                      _.input_is_disabled === 'True' ? '#e9e9e9' : '',
                    pointerEvents: _.input_is_disabled === 'True' ? 'none' : '',
                  }}
                  className='add-on-healthcare'
                  key={index}
                >
                  <div className='image-wrapper'>
                    <img
                      src={
                        _.item_images ||
                        'images/addon/zero_healthcare/zero-healthcare.png'
                      }
                      alt='add-on-image'
                    />
                  </div>
                  <div className='add-on-details'>
                    <h5>{_.item_name}</h5>
                    <div
                      className='description'
                      dangerouslySetInnerHTML={{ __html: _.item_desc }}
                    />
                    <p className='add-on-price'>
                      {monetaryUnit}{' '}
                      <span>
                        {' '}
                        {(
                          Number(_.item_amt) /
                          (currentCurrency === 'MYR'
                            ? 1
                            : exchangeCurrency.addOnCurrency)
                        ).toFixed(2)}
                      </span>
                    </p>

                    {isReturn &&
                    healthCareAddOn.fee > 0 &&
                    !healthCareAddOn.isReturn &&
                    returnHealthCarePackages.find(
                      (_r) =>
                        _.item_name === _r.item_name &&
                        _.item_amt === _r.item_amt
                    ) ? (
                      <div
                        className='add-for-return'
                        onClick={() => {
                          if (_.input_is_disabled === 'True') {
                            return;
                          }

                          setHealthCareAddOn({
                            addOnId: _.add_on_id,
                            item: _.item_name,
                            fee: Number(_.item_amt) * 2 * noOfPax,
                            isReturn: true,
                            direction: _.direction,
                            noOfPax,
                          });

                          sessionStorageSetItem(
                            'healthCareAddOn',
                            JSON.stringify({
                              addOnId: _.add_on_id,
                              item: _.item_name,
                              fee: Number(_.item_amt) * 2 * noOfPax,
                              isReturn: true,
                              addOnIndex: index,
                              direction: _.direction,
                              noOfPax,
                            })
                          );

                          alert('Add On added to cart');

                          setIsHealthCareShowed(false);
                        }}
                      >
                        Add for return trip
                      </div>
                    ) : isReturnTrip &&
                      healthCareAddOn.fee > 0 &&
                      healthCareAddOn.isReturn &&
                      returnHealthCarePackages.find(
                        (_r) =>
                          _.item_name === _r.item_name &&
                          _.item_amt === _r.item_amt
                      ) ? (
                      <div
                        className='add-for-return'
                        style={{ backgroundColor: 'red' }}
                        onClick={() => {
                          const item = returnHealthCarePackages.find(
                            (_r) =>
                              _.item_name === _r.item_name &&
                              _.item_amt === _r.item_amt
                          );

                          if (item.input_is_disabled === 'True') {
                            return;
                          }

                          setHealthCareAddOn({
                            addOnId: [_.add_on_id, , item.add_on_id],
                            item: item.item_name,
                            fee: Number(item.item_amt) * noOfPax,
                            isReturn: false,
                            addOnIndex: index,
                            direction: [_.direction, item.direction],
                            noOfPax,
                          });

                          sessionStorageSetItem(
                            'healthCareAddOn',
                            JSON.stringify({
                              addOnId: [_.add_on_id, , item.add_on_id],
                              item: item.item_name,
                              fee: Number(item.item_amt) * noOfPax,
                              isReturn: false,
                              addOnIndex: index,
                              direction: [_.direction, item.direction],
                              noOfPax,
                            })
                          );
                        }}
                      >
                        Remove for return trip
                      </div>
                    ) : (
                      ''
                    )}
                  </div>

                  <div
                    className={`package-add${
                      healthCareAddOn.addOnIndex === index ? ' added' : ''
                    }`}
                    style={{
                      backgroundColor:
                        _.input_is_disabled === 'True' ? 'grey' : '',
                    }}
                    onClick={() => {
                      if (_.input_is_disabled === 'True') {
                        return;
                      }

                      if (healthCareAddOn.addOnIndex === index) {
                        return;
                      }

                      setHealthCareAddOn({
                        addOnId: _.add_on_id,
                        item: _.item_name,
                        fee: Number(_.item_amt) * noOfPax,
                        addOnIndex: index,
                        direction: _.direction,
                        noOfPax,
                      });

                      if (!isReturnTrip) {
                        alert('Add On added to cart');

                        setIsHealthCareShowed(false);
                      } else {
                        if (returnHealthCarePackages.length > 0) {
                          setIsReturn(true);
                        }
                      }
                    }}
                  >
                    {healthCareAddOn.addOnIndex === index ? (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 448 512'
                      >
                        <path d='M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z' />
                      </svg>
                    ) : (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 448 512'
                      >
                        <path d='M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z' />
                      </svg>
                    )}
                  </div>
                </div>
              ))
            : ''}

          {departHealthCarePackages.length < 1 &&
          returnHealthCarePackages.length > 0
            ? returnHealthCarePackages.map((_, index) => (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '10px',
                    padding: '10px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '10px',
                    backgroundColor:
                      _.input_is_disabled === 'True' ? '#e9e9e9' : '',
                    pointerEvents: _.input_is_disabled === 'True' ? 'none' : '',
                  }}
                  className='add-on-healthcare'
                  key={index}
                >
                  <div className='image-wrapper'>
                    <img
                      src={
                        _.item_images ||
                        'images/addon/zero_healthcare/zero-healthcare.png'
                      }
                      alt='add-on-image'
                    />
                  </div>
                  <div className='add-on-details'>
                    <h5>{_.item_name}</h5>
                    <div
                      className='description'
                      dangerouslySetInnerHTML={{ __html: _.item_desc }}
                    />
                    <p className='add-on-price'>
                      {monetaryUnit}{' '}
                      <span>
                        {(
                          Number(_.item_amt) /
                          (currentCurrency === 'MYR'
                            ? 1
                            : exchangeCurrency.addOnCurrency)
                        ).toFixed(2)}
                      </span>
                    </p>
                  </div>

                  <div
                    className={`package-add${
                      healthCareAddOn.addOnIndex === index ? ' added' : ''
                    }`}
                    style={{
                      backgroundColor:
                        _.input_is_disabled === 'True' ? 'grey' : '',
                    }}
                    onClick={() => {
                      if (_.input_is_disabled === 'True') {
                        return;
                      }

                      if (healthCareAddOn.addOnIndex === index) {
                        return;
                      }

                      setHealthCareAddOn({
                        addOnId: _.add_on_id,
                        item: _.item_name,
                        fee: Number(_.item_amt) * noOfPax,
                        addOnIndex: index,
                        direction: _.direction,
                        noOfPax,
                      });

                      if (!isReturnTrip) {
                        alert('Add On added to cart');

                        setIsHealthCareShowed(false);
                      } else {
                        if (returnHealthCarePackages.length > 0) {
                          setIsReturn(true);
                        }
                      }
                    }}
                  >
                    {healthCareAddOn.addOnIndex === index ? (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 448 512'
                      >
                        <path d='M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z' />
                      </svg>
                    ) : (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 448 512'
                      >
                        <path d='M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z' />
                      </svg>
                    )}
                  </div>
                </div>
              ))
            : ''}
        </div>
      </div>
    </div>
  );
};

export default HealthCare;
